<template>
<Layout 
  :hideHeader="info.header_type == 1"
  :hideFooter="info.footer_type !== 0"
  :eventStatu="eventStatu"
  :info="info"
  :scrollTop="scrollTop"
  :linkType="info.link_type"
  :loginType="loginType"
>
  <div slot="header"></div>
  <div slot="wap-prev" v-if="info.header_type === 2"></div>
  <div slot="wap-next"></div>
  <div slot="sub-nav"></div>

  <div class="event-banner" style="background: #fff">
    <EventBanner 
      :info="info" 
      :eventStatu="eventStatu" 
      :btnLabel="btnLabel" 
      :showCode="scrollTopMobile > codeHeight" 
    />
  </div>

  <div style="background: #fff">
    <div class="layout-content">
      <div class="content-wrapper">
        <div class="event-main" :class="{'no-right': (info.side_control && info.side_control.status !== 1) || compatible}" ref="eventMain">
          <EventSpeakers :data="info.content"></EventSpeakers>
        </div>
        <div class="event-aside" v-if="info.side_control && info.side_control.status === 1 & !compatible">
          <EventLocation :info="info"></EventLocation>
        </div>
      </div>
    </div>
    <GoTop class="return-top" v-if="!isMobile" />
  </div>
</Layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '../../utils'

import serviceEvent from '../../service/event.service'

import Layout from '../../components/layout/Layout'
import GoTop from '../../components/gotop/GoTop'
import EventBanner from './EventBanner'
import EventLocation from './EventLocation'
import EventSpeakers from './EventSpeakers'

export default {
  name: 'event-self',
  components: {
    Layout,
    GoTop,
    EventBanner,
    EventLocation,
    EventSpeakers
  },
  data () {
    return {
      // 活动id
      aid: this.$route.params.aid || this.$route.query.id,
      // 移动端滚动条高度
      scrollTopMobile: 0,
      // 移动端悬浮穿需要显示的高度
      codeHeight: 0,
      scrollTop: 0,
      asideTop: 0,
      loading: false,
      info: {},
      btnLabel: '',
      compatible: false,
      loginType: 0
    }
  },
  computed: {
    ...mapState([
      'loginUser',
      'nowTime',
      'isMobile'
    ]),
    eventStatu () {
      let time = parseInt(this.nowTime / 1000)
      return time < this.info.start_time ? 'wait' : time < this.info.end_time ? 'processing' : 'end'
    }
  },
  watch: {
    info: function (newVal) {
      switch (this.eventStatu) {
        case 'wait':
          this.btnLabel = newVal.link.desc_before || '活动未开始'
          return
        case 'end':
          this.btnLabel = newVal.link.desc_after || '活动结束'
          return
        default:
          this.btnLabel = newVal.link.desc || '活动进行中'
      }
    }
  },
  created () {
    if (this.aid) {
      if (this.aid === 'preview') {
        // 预览状态数据
        window.addEventListener('message', this.previewPage)
      } else {
        // 兼容特定的两个活动
        if (Number(this.aid) === 113 || Number(this.aid) === 122) {
          this.compatible = true
        }
        let params = {id: Number(this.aid)}
        serviceEvent.getEventInfo(params).then(res => {
          if (res.login_type) {
            this.getSigninInfo()
          }
          res.content = JSON.parse(res.content)
          
          // console.log(res.content)
          this.info = res
          this.loginType = res.login_type
          document.title = `${this.info.title}_InfoQ精选活动`
          // 微信分享
          if (res.share_type === 1) {
            let opt = this.InitShareMsg(res.share_content)
            utils.shareWeixin(opt)
          } else {
            utils.shareWeixin()
          }
        }).catch(err => {
          console.log('err ==> ', err)
          setTimeout(() => {
            this.$router.push('/404')
          }, 1000)
        })
      }
    } else {
      setTimeout(() => {
        this.$router.push('/404')
      }, 1000)
    }
  },
  mounted () {
    /**
     * 活动页没有登录都会自动弹出登录框
     */
    // if (!this.loginUser) {
    //   utils.login({}, true)
    // }
    if (!this.isMobile) {
      let $applyBtn = document.querySelector('.apply-card')
      this.scrollTop = $applyBtn.getBoundingClientRect().top
    }

    this.codeHeight = this.$refs.eventMain.getBoundingClientRect().top
    window.addEventListener('scroll', this.listenerScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  },
  methods: {
    ...mapActions(['getSigninInfo']),
    listenerScroll (event) {
      this.scrollTopMobile = window.scrollY
    },

    previewPage (event) {
      console.log('message event===> ', event)
      this.info = event.data
    },

    InitShareMsg (info) {
      return {
        title: info.title,
        desc: info.desc,
        imgUrl: info.logo
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
.layout-content {
  background: #fff;
}
.content-wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;

  & .event-main {
    flex: 1;
    padding-right: 42px;

    &.no-right {
      flex: none;
      width: 845px;
      margin: 0 auto;
      padding-right: 0;

      & ::v-deep {
        & .guest-b .item {
          width: 48%;
        }

        & .guest-a {
          justify-content: space-between;
          &.double,
          &.single {
            justify-content: center;
          }
          .item {
            width: 30%;
            &:nth-child(3n-1) {
              margin: 0;
            }
          }
        }
      }
    }
  }

  & .event-aside {
    flex: none;
    width: 302px;

    & ::v-deep .location {
      position: sticky; top: 90px;
      width: 302px;
    }
  }
}

@media screen and (max-width: 768px) {
  .layout-content {
    padding: 0;

    & .event-main {
      padding-right: 0;

      &.no-right {
        width: 100%;

        & ::v-deep {
          & .guest-b .item {
            width: 100%;
          }

          & .guest-a {
            justify-content: space-between;
            &.double,
            &.single {
              justify-content: space-between;
            }
            .item {
              width: 45%;
              &:nth-child(3n-1) {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }

  .content-wrapper {
    flex-direction: column;

    & .event-aside {
      width: 100%;

      & ::v-deep .location {
        position: relative; top: 0;
        width: auto;
      }
    }
  }
}
</style>
